import { ReceiptViewerPage } from './ReceiptViewerPage';

export const receipt_viewer_path = '/@/order/customer_order/receipt_viewer';
export const receiptViewerRouter = {
  [receipt_viewer_path]: ReceiptViewerPage,
};
